import { formatMessage } from './formatMessage';

export type TLabel = {
  text: string;
  title: string;
};

export interface ILabelsContainer {
  labels: {
    [key: string]: TLabel;
  };
}

/**
 * Dado un nombre de etiqueta, devuelve el texto que esa etiqueta contiene en
 * el idioma actual. En este momento, lo único que hace realmente esta función
 * es devolver la variable del window con el mismo nombre que se está
 * pidiendo.
 *
 * La idea de implementar esta función, es que en un futuro la fuente de la
 * que provienen las labels pueda ser más diversa.
 *
 * Permite el pasaje de tokens para el reemplazo automático de los mismos.
 *
 * @param outerWindow - En librerías que puedan trabajar tanto en Browser como en Node es requerido pasar el window como parámetro para evitar que la función vaya directamente al window.
 *
 *
 * @example
 *
 * // Suponemos la etiqueta msgUsu = { text: 'Usuario <TOK1>', title: 'Usuario <TOK1>' }
 *
 * getLabel('msgUsu' , {
 *   text: {
 *     TOK1: 'admin',
 *   },
 *   title: {
 *     TOK1: 'no disponible',
 *   }
 * })
 */
export function getLabel(
  name: string,
  replaceTokens?: {
    text?: Record<string, string>;
    title?: Record<string, string>;
  },
  outerWindow?: any,
): TLabel {
  const actualWindow = outerWindow ?? window;
  const label = {
    ...((actualWindow as unknown as ILabelsContainer).labels[name] ?? {
      text: `${name}`,
      title: `${name}`,
    }),
  };

  if (replaceTokens?.text !== undefined)
    label.text = formatMessage(label.text, replaceTokens.text);
  if (replaceTokens?.title !== undefined)
    label.title = formatMessage(label.title, replaceTokens.title);

  return label;
}

function isLabel(a: string | TLabel): a is TLabel {
  return typeof a !== 'string';
}

export function getLabelName(a: string | TLabel) {
  return isLabel(a) ? a.text : a;
}

export function getLabelTooltip(a: string | TLabel) {
  return isLabel(a) ? a.title : '';
}
